<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section class="p-relative">
    <h3 class="mb-2 text-center">Reject Call for</h3>

    <h4 class="mb-1 text-center">{{ call.prisoner.firstname }} {{ call.prisoner.lastname }}
      (#{{ call.prisoner.prisoner_number }})</h4>

    <section>
      <label>Please provide a reason for the visitor (optional)</label>

      <b-form-textarea
        v-if="call.prison.prison_group_id !== '21a4a4957bfd41c1836ac1d127581975'"
        v-model="reason"
        maxlength="100"
        placeholder="Enter reason for rejecting the call"/>

      <select
        v-else
        class="form-control"
        v-model="reason"
      >
        <option
          v-for="(reason, index) in rejectionReasons"
          :key="index"
          :value="reason"
        >{{ reason }}</option>
      </select>
    </section>

    <section class="d-inline-flex full-width mt-2" :class="{'disabled': loading}">
      <div class="ui-spacer"></div>
      <b-button class="mr-2" @click="close()">Close</b-button>
      <b-button variant="danger" @click="rejectCall()">Reject Call</b-button>
    </section>
  </section>
</template>
<!--eslint-enable-->

<script>
import VisitService from '@/services/VisitService';
import { ERROR_CODES } from '@/util/errorCodes';

export default {
  components: {},
  props: {
    call: {
      required: true,
      type: Object,
    },
    redirect: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      reason: '',
      rejectionReasons: [
        'Needs to be rescheduled by establishment',
        'Resident or Caller wants to reschedule',
        'Admin error',
        'Resident  can’t make it',
        'Operational reasons',
        'Resident has already used their allocated video calls',
        'Resident doesn’t want this visit',
        'Resident has left the establishment',
        'Resident has moved wing',
        'Not accepted in time',
        'Not approved to contact',
        'Change of Caller(s)',
      ],
    };
  },
  mounted() {

  },
  methods: {
    rejectCall() {
      this.loading = true;
      VisitService.rejectVisit(this.call._id, { cancellation_reason: this.reason, metricAction: 'WebPortalNew' }).then(() => {
        this.$toast.success('The video call has been rejected', {
          toastClassName: ['toast-std', 'success-toast'],
        });

        if (this.redirect) {
          this.$router.push(this.redirect);
        }

        this.close();
      }).catch(err => {
        const errorCheck = err && err.response && err.response.data;
        let message = 'Something went wrong rejecting the visit, please refresh the page and try again';

        if (errorCheck && err.response.data === ERROR_CODES.VISIT.NOT_OF_STATUS) {
          message = 'Cannot reject visit as it does not have a status of Requested. Please refresh the page.';
        }

        this.$toast.error(message, {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    close() {
      this.$emit('close', true); // emit a close
    },
  },
};
</script>
